import React, { useEffect } from "react";
import { Layout } from "antd";
import ReactGA from "react-ga4";
import "@fontsource/sarabun";
import RenderRoute from "./RenderRoute";
import "./App.css";
import GlobalStyles from "./GlobalStyles";
import NavBar from "./containers/NavBar/NavBar";

const { Content, Footer } = Layout;

const GA_MEASUREMENT_ID = "G-KDJR41J5BF";

const Root = () => {
  return (
    <>
      <GlobalStyles />
      <App />
    </>
  );
};

export default Root;

export const App = () => {
  useEffect(() => {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    ReactGA.send("pageview");
  }, []);

  return (
    <Layout>
      <NavBar />
      <Content className="site-layout">
        <RenderRoute />
      </Content>
      <Footer style={{ textAlign: "center" }}>
        Copyright © 2021 Scripture Union Thailand
      </Footer>
    </Layout>
  );
};
